import { render, staticRenderFns } from "./DataListEvacuationPlans.vue?vue&type=template&id=0ff23606&scoped=true&"
import script from "./DataListEvacuationPlans.vue?vue&type=script&lang=js&"
export * from "./DataListEvacuationPlans.vue?vue&type=script&lang=js&"
import style0 from "./DataListEvacuationPlans.vue?vue&type=style&index=0&id=0ff23606&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff23606",
  null
  
)

export default component.exports